import { validateDateRange } from "../../utils";

export const subcontractorValidationRules = (values) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.name) errors.name = "Name is required";
  else if (values.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (values.primaryPhone && !phoneRegex.test(values.primaryPhone))
    errors.primaryPhone = "Enter valid number (with country code)";

  return errors;
};

export const contractValidationRules = (values) => {
  const errors = {};

  if (!values.title) errors.title = "Contract title required";
  else if (values.title.length < 3) errors.title = "Title must be at least 3 characters";
  if (!values.startDate) errors.startDate = "Start date required";
  if (!values.endDate) errors.endDate = "End date required";
  if (!values.contractValue) errors.contractValue = "Contract amount required";
  if (!values.subcontractorId) errors.subcontractorId = "Please select a subcontractor";
  if (!values.projectId) errors.projectId = "Please select a project";

  const dateErrors = validateDateRange({
    fieldName: "endDate",
    startDateKey: "startDate",
    endDateKey: "endDate",
    startDate: values.startDate,
    endDate: values.endDate,
  });

  if (dateErrors.startDate) errors.startDate = dateErrors.startDate;
  if (dateErrors.endDate) errors.endDate = dateErrors.endDate;

  return errors;
};
